import { useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
const AWSRegionsUrl = "/plugins/org.graylog.plugins.archive/backends/s3/regions";
export const AWS_REGIONS_QUERY_KEY = ["aws-regions"];
const fetchAWSRegions = () => fetch("GET", qualifyUrl(AWSRegionsUrl)).then((response) => response.regions).catch((error) => {
  var _a, _b, _c;
  const errorMessage = (_c = (_b = (_a = error.additional) == null ? void 0 : _a.body) == null ? void 0 : _b.message) != null ? _c : error.message;
  UserNotification.error(`Fetching AWS regions failed.: ${errorMessage}`, "Could not retrieve AWS regions.");
  throw error;
});
const useAWSRegions = () => useQuery({
  queryKey: AWS_REGIONS_QUERY_KEY,
  queryFn: fetchAWSRegions,
  retry: false
});
export default useAWSRegions;
